// extracted by mini-css-extract-plugin
export default {"title":"Title-module__title__kuAeDQO"};